import React, {
  useEffect,
  useState
} from 'react';
import {
  RaasAssessmentDto,
  RecommendationGenerationStatusDto
} from '../../apis/nhe-remediation-service/nhe-remediation-service.dtos';

type BulkCancelModalState = {
  processedCount: number;
  successCount: number;
  failureCount: number;
  isProcessing: boolean;
  isComplete: boolean;
}

const defaultState: BulkCancelModalState = {
  processedCount: 0,
  successCount: 0,
  failureCount: 0,
  isProcessing: false,
  isComplete: false
};

type BulkCancelModalProps = {
  selectedAssessments: RaasAssessmentDto[];
  putRaaSAssessment: (assessment: RaasAssessmentDto) => Promise<RaasAssessmentDto>;
  onComplete: (successCount: number, failureCount: number, failedIds: number[]) => void;
  onClose: () => void;
};

export const BulkCancelModal = (props: BulkCancelModalProps): JSX.Element => {

  const [state, setState] = useState<BulkCancelModalState>(defaultState);

  const processCancellations = async () => {
    setState((prevState) => ({
      ...prevState,
      isProcessing: true
    }));

    let successCount = 0;
    let failureCount = 0;
    const failedIds: number[] = [];
    let processedCount = 0;

    // Process one at a time sequentially with delay
    for (const assessment of props.selectedAssessments) {
      try {
        await props.putRaaSAssessment({
          ...assessment,
          recGenerationStatus: RecommendationGenerationStatusDto.CANCELLED_ADMIN_REQUEST,
          isActive: false
        });
        successCount++;
      } catch (error) {
        failureCount++;
        failedIds.push(assessment.id);
      }

      processedCount++;

      // Update state after each assessment
      setState((prevState) => ({
        ...prevState,
        processedCount,
        successCount,
        failureCount
      }));

      // Add delay between requests (100ms) - but not after the last one
      if (processedCount < props.selectedAssessments.length) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }
    }

    // Mark as complete
    setState((prevState) => ({
      ...prevState,
      isProcessing: false,
      isComplete: true
    }));

    // Notify parent component
    props.onComplete(successCount, failureCount, failedIds);
  };

  useEffect(() => {
    processCancellations();
  }, []);

  return (
    <div className="u-els-padding-2x">
      <h2>Cancelling Assessments...</h2>

      <div className="o-els-container u-els-margin-top-2x">
        <div className="o-els-container">
          <strong>Progress:</strong> {state.processedCount} / {props.selectedAssessments.length}
        </div>
        <div className="o-els-container">
          <strong>Successful:</strong> {state.successCount}
        </div>
        <div className="o-els-container">
          <strong>Failed:</strong> {state.failureCount}
        </div>
      </div>

      {state.isComplete && (
        <div className="o-els-container u-els-margin-top-2x">
          <button
            type="button"
            className="c-els-button c-els-button--primary c-els-button--small"
            onClick={props.onClose}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
};

export default BulkCancelModal;
